module.exports = __webpack_public_path__ + "img/titleTwo11.bf299b9e.png";